import { roles, settings } from 'consts'
import { useEffect } from 'react'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getPageSize from 'utils/getPageSize'

interface useInitProps {
  pageSizes: Array<number>
  setDataLoaded: Function
  setShowOverlay: Function
  setPageSizesObj: Function
  setValue: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    const isSuperAdmin: boolean = hasAnyRole([roles.superAdmin])
    const defaultPageSizeDevices: any = getPageSize(settings.pageSizeDevices)
    const defaultPageSizeUsers: any = getPageSize(settings.pageSizeUsers)
    const defaultPageSizeSites: any = getPageSize(settings.pageSizeSites)
    const defaultPageSizeCostCenters: any = getPageSize(settings.pageSizeCostCenters)
    const defaultPageSizeSuperadmins: any = isSuperAdmin
      ? getPageSize(settings.pageSizeSuperadmins)
      : null

    let pageSizesObj: any = []
    props.pageSizes.forEach((pageSize) => {
      const pageSizeObj: {} = {
        id: pageSize,
        name: pageSize,
      }
      pageSizesObj.push(pageSizeObj)
      if (defaultPageSizeDevices === pageSize) {
        props.setValue(settings.pageSizeDevices, pageSizeObj)
      }
      if (defaultPageSizeUsers === pageSize) {
        props.setValue(settings.pageSizeUsers, pageSizeObj)
      }
      if (defaultPageSizeSites === pageSize) {
        props.setValue(settings.pageSizeSites, pageSizeObj)
      }
      if (defaultPageSizeCostCenters === pageSize) {
        props.setValue(settings.pageSizeCostCenters, pageSizeObj)
      }
      if (isSuperAdmin && defaultPageSizeSuperadmins === pageSize) {
        props.setValue(settings.pageSizeSuperadmins, pageSizeObj)
      }
    })
    props.setPageSizesObj(pageSizesObj)
    props.setDataLoaded(true)
    props.setShowOverlay(false)
  }, [])
}

export default useInit
